var styles = {"stack":"Stack-module_stack__19jn1","fullHeight":"Stack-module_fullHeight__5_VCS","xxs":"Stack-module_xxs__2-v8X","xs":"Stack-module_xs__sASYt","sm":"Stack-module_sm__1ncNx","md":"Stack-module_md__2xfIF","lg":"Stack-module_lg__3TUAE","xl":"Stack-module_xl__2wAfG","xxl":"Stack-module_xxl__3s_VC"};

export { styles as default };
//# sourceMappingURL=Stack.module.css.js.map
